/* eslint-env browser, jquery */
import 'bootstrap';
import domify from 'domify';
import page from 'modules/ab-page-js';
import $ from 'jquery';
import querystring from 'querystring';
import scrollIntoView from 'scroll-into-view';
import ContactForm from 'auth0-contact-form';
import { ContactUsForm } from 'components';
import { render as clientRender, unmountComponentAtNode } from 'react-dom';
import React from 'react';
import AnimationScroll from 'modules/animation-scroll';
import container from 'modules/section-content';
import splash from './view/landing.pug';
import metadata from './metadata.json';

const animationScroll = new AnimationScroll();
const metricsLib = window.metricsLib;

export default function register() {
  page('/b2b-saas', render, snippets);
  page.exit('/b2b-saas', unmountContactForm, resetAnimation);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);
  /* eslint-env browser */
  clientRender(
    <ContactUsForm
      source="b2b-saas"
      subject="New lead from B2B SaaS landing page"
      formId="b2b-saas-contact-form"
    />,
    document.querySelector('.contact-us-app')
  );
  return next();
}

function snippets(ctx, next) {
  setupClickHandlers();
  setupContactForm();
  next();
}

function setupClickHandlers() {
  const frictionlessTargetElem = document.getElementById('scroll-spy-frictionless');
  const extensibleTargetElem = document.getElementById('scroll-spy-extensible');
  const secureTargetElem = document.getElementById('scroll-spy-secure');
  const adaptiveTargetElem = document.getElementById('scroll-spy-adaptive');

  const $frictionlessSection = $('.b2b-saas-page section[role="navigation"] .section-frictionless');
  const $extensibleSection = $('.b2b-saas-page section[role="navigation"] .section-extensible');
  const $secureSection = $('.b2b-saas-page section[role="navigation"] .section-secure');
  const $adaptiveSection = $('.b2b-saas-page section[role="navigation"] .section-adaptive');

  $frictionlessSection.on('click', () => scrollIntoView(frictionlessTargetElem, { time: 500 }));
  $extensibleSection.click(() => scrollIntoView(extensibleTargetElem, { time: 500 }));
  $secureSection.click(() => scrollIntoView(secureTargetElem, { time: 500 }));
  $adaptiveSection.click(() => scrollIntoView(adaptiveTargetElem, { time: 500 }));
}

function setupContactForm() {
  const salesContactFormOptions = {
    onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:b2b-contact-form', metricsData);
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:b2b-contact-form', metricsData);
    },
    source: 'b2b-saas'
  };
  const salesContactForm = new ContactForm(salesContactFormOptions);

  const ttsMetadata = { place: 'hero', type: 'button', text: 'talk to sales' };
  const salesFormButton = document.querySelector('.open-contact-form-modal');
  salesFormButton.addEventListener('click', () =>
      metricsLib.track('click:contact-sales', { trackData: { ...ttsMetadata } }, () => window.location.assign(`/contact-us?${querystring.stringify(ttsMetadata)}`))
  );
}

function unmountContactForm(ctx, next) {
  unmountComponentAtNode(document.querySelector('.contact-us-app'));
  next();
}

function resetAnimation(ctx, next) {
  animationScroll.reset();
  next();
}



// WEBPACK FOOTER //
// ./src/pages/b2b-saas/client.js